<template>
    <span class="typing-text text--primary text-body-1">
        {{ displayedText }}
    </span>
</template>

<script>
export default {
    name: 'TypingText',

    props: {
        text: {
            type: String,
            required: true,
        },

        speed: {
            type: Number,
            default: 20,
        }
    },

    data() {
        return {
            displayedText: '',
            timeout: null
        }
    },

    mounted() {
        this.typeText()
    },

    watch: {
        text() {
            clearTimeout(this.timeout)
            this.typeText()
        }
    },

    beforeDestroy() {
        clearTimeout(this.timeout)
    },

    methods: {
        typeText() {
            this.displayedText = ''

            const characters = Array.from(this.text)

            let index = 0

            const write = () => {
                if (index < characters.length) {
                    this.displayedText += characters[index]
                    index++

                    this.timeout = setTimeout(write, this.speed)
                }
            }

            write()
        }
    }
}
</script>

<style scoped>
.typing-text {
    white-space: pre-wrap;
    word-break: break-word;
}
</style>